// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/towbars",
    name: "Towbars",
    meta: { title: "Kljuke" },
    component: () => import(/* webpackChunkName: "Towbars List" */ "@/Modules/Towbar/Views/List")
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/towbars/details/:id",
    name: "Towbar",
    component: () => import(/* webpackChunkName: "Towbar" */ "@/Modules/Towbar/Views/Edit")
  },
  {
    path: "/towbars/new",
    name: "New Towbar",
    meta: { title: "Nova Kljuka" },
    component: () => import(/* webpackChunkName: "Towbar" */ "@/Modules/Towbar/Views/Edit")
  }
]
